<template>
  <div class="row step-section">
    <div class="col-md-6 col-md-offset-3">
      <div class="confirmation-text">
        <div class="form-group form-inline text-left">
          <span>I, </span>

          <text-input field-name="client_consulter" :show-input-box="false">
          </text-input>
        </div>
        <p class="text-left"> 
        agree that I have discussed and understood all the information
        contained within this annual veterinary consultation.
        </p>

        <p class="text-left">
        I thereby agree to abide by the correct and safe usage, storage and
        withholding times of all products registered as veterinary medicines by
        the ACVM, as discussed in this consultation.
        </p>

        <p class="text-left">
        All medications discussed are for ANIMAL USE ONLY.
        </p>

        <p class="text-left">
        Use as directed. Store out of reach of children, in the appropiate
        environment - fridge if required, and out of sunlight.
        </p>

        <p class="text-left">
        I will contact VetSouth Ltd straight away should I have an adverse
        reaction to any drug administered that was prescribed by VetSouth Ltd.
        </p>

        <p class="text-left">Date: {{ today }}</p>
        <p class="text-left">Agree <input type="checkbox" v-model="signed" :disabled="isReadOnly"></p>
        <!-- <check&#45;box label="Agree" -->
        <!--            field&#45;name="signed"> -->
        <!-- </check&#45;box> -->

      <div v-if="signed && !isReadOnly">
          <button @click="saveAndRedirectHome" type="button" class="btn btn-primary">
            Save and continue
          </button>
      </div>
      </div>
    </div>
  </div>
</template>

<script>
import baseComponent from '@/mixins/base_consult_component_v2'

export default {
  name: 'Disclaimer',
  mixins: [ baseComponent ],
  data() {
    return {
      signed: false,
      signed_at: null,
    }
  },
  computed: {
    today: function () {
      var today = new Date();
      var dd = String(today.getDate()).padStart(2, '0');
      var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
      var yyyy = today.getFullYear();

      return `${dd}/${mm}/${yyyy}`;
    },
  },
  methods: {
    saveAndRedirectHome: function ()
    {
      this.onSubmit()
      this.$store.dispatch('alert/success', {
        message: 'Data has been saved locally', persist: true
      });
      this.$router.push('/')
    },
  },
  watch:
  {
    'signed': function (value)
    {
      let signed_at = value ? (new Date()).toJSON() : null
      this.setFieldValue({fieldName: 'signed_at', value: signed_at})
      this.setFieldValue({fieldName: 'signed', value: value})
    }
  }
};
</script>

<style scoped>
.confirmation-text p {
  font-size: 20px;
}
</style>
